// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"62089c8b","89":"814c6a5e","175":"faf2cbaa","237":"605f8850","358":"e6dd6056","389":"d2160642","553":"88a94f8a","782":"2c265b5f","896":"e34706b4"}[chunkId] + ".chunk.js";
};